// extracted by mini-css-extract-plugin
module.exports = {"text-skeleton":"styles_text-skeleton__7g_WN","skeleton-animation":"styles_skeleton-animation__BHXv_","label":"styles_label__MzgGb"};